/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warmer colours mark higher values, cooler colours lower ones.`)
};

const es_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los colores más cálidos marcan valores más altos, los colores más fríos, valores más bajos.`)
};

const de_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wärmere Farben markieren höhere Werte, kühlere Farben niedrigere.`)
};

const nl_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warmere kleuren markeren hogere waarden, koelere kleuren lagere.`)
};

const fr_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les couleurs chaudes marquent des valeurs plus élevées, les couleurs froides des valeurs plus basses.`)
};

const it_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I colori più caldi segnano valori più alti, i colori più freddi valori più bassi.`)
};

const pt_br2_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cores mais quentes marcam valores mais altos, cores mais frias, valores mais baixos.`)
};

const pt_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cores mais quentes marcam valores mais altos, cores mais frias valores mais baixos.`)
};

const ja_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暖色は高い値を、寒色は低い値を示します。`)
};

const zh_heat_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较暖的颜色代表较高的数值，较冷的颜色代表较低的数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_ex2", locale)
	if (locale === "en") return en_heat_ex2(inputs)
	if (locale === "es") return es_heat_ex2(inputs)
	if (locale === "de") return de_heat_ex2(inputs)
	if (locale === "nl") return nl_heat_ex2(inputs)
	if (locale === "fr") return fr_heat_ex2(inputs)
	if (locale === "it") return it_heat_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_heat_ex2(inputs)
	if (locale === "pt") return pt_heat_ex2(inputs)
	if (locale === "ja") return ja_heat_ex2(inputs)
	return zh_heat_ex2(inputs)
};